import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { View } from "@src/components/View";
import { Text } from "@src/components/Text";
import { ScreenContainer } from "@src/components/ScreenContainer";
import { Button } from "@src/components/Button";
import { SystemBars } from "react-native-edge-to-edge";
import { BackgroundGradient } from "../../../components/BackgroundGradient";
import { GradientBorderWrapper } from "@src/components/GradientBorderWrapper";
import { ContactUsButton } from "@src/components/ContactUsButton";
import LogoIcon from "@src/assets/svgs/logo-icon.svg";
import LogoType from "@src/assets/svgs/logo-type.svg";

interface SignInScreenProps {
  onSignIn: () => void;
  disabled: boolean;
}

export function SignInScreen({ onSignIn, disabled }: SignInScreenProps) {
  const { theme } = useUnistyles();

  return (
    <>
      <SystemBars style="light" />
      <BackgroundGradient>
        <ScreenContainer edges={["top", "bottom"]} style={{ backgroundColor: "transparent" }}>
          <View justifyContent="center" alignItems="center" mt="8xl">
            <View flexDirection="row" alignItems="center">
              <LogoIcon width={75} height={70} />
              <LogoType width={195} height={70} color={theme.colors.interactive.buttons.default_foreground} />
            </View>
          </View>
          <View flex={1} alignItems="center" px="6xl" mt="14xl">
            <View mb="6xl">
              <Text textStyle="h3/regular" textAlign="center" style={styles.text}>
                Welcome to Visioni.
              </Text>
            </View>
            <View mb="6xl">
              <Text textStyle="sm/regular" textAlign="center" style={styles.text}>
                Sign in to access your alarm schedules{"\n"}and camera monitoring.
              </Text>
            </View>
            <View w="100%" maxW={255}>
              <GradientBorderWrapper>
                <Button
                  label="Sign In"
                  variant="primary"
                  onPress={onSignIn}
                  disabled={disabled}
                  size="md"
                  textStyle="md/regular"
                />
              </GradientBorderWrapper>
            </View>
            <Text textStyle="sm/regular" textAlign="center" mt="xl" style={styles.text}>
              Secured by Auth0
            </Text>
          </View>
          <View flexDirection="row" justifyContent="center" alignItems="center" mb="xl" gap="xs">
            <Text textStyle="sm/regular" textAlign="center" style={styles.text}>
              Having a problem?
            </Text>
            <ContactUsButton />
          </View>
        </ScreenContainer>
      </BackgroundGradient>
    </>
  );
}

const styles = StyleSheet.create((theme) => ({
  text: {
    color: theme.colors.interactive.buttons.default_foreground,
  },
}));
